import { Grid, IconButton, Tooltip } from '@mui/material'
import { useContext, useEffect, useState } from 'react'
import { MdAdd, MdArrowBack } from 'react-icons/md'
import { GlobalContext } from '../../../App'
import Programa from '../../../components/Programa/Programa'
import Edicao from './Edicao'
import dayjs from 'dayjs'
import PrimeTable from '../../../components/PrimeTable'

const MedicoCRUD = () => {
  const { localAtendimento } = useContext(GlobalContext)

  const [tela, setTela] = useState('lista')
  const [ferramentas, setFerramentas] = useState()
  const [dados, setDados] = useState(null)

  const voltar = () => {
    setTela('lista')
    setDados(undefined)
  }

  const handleClick = (linha) => {
    setDados(linha)
    setTela('opcoes')
  }

  useEffect(() => {
    switch (tela) {
      case 'lista':
        setFerramentas(
          <Tooltip title="Adicionar">
            <IconButton onClick={() => setTela('opcoes')}>
              <MdAdd />
            </IconButton>
          </Tooltip>,
        )
        break
      case 'opcoes':
        setFerramentas(
          <Tooltip title="Voltar">
            <IconButton onClick={voltar}>
              <MdArrowBack />
            </IconButton>
          </Tooltip>,
        )
        break
      default:
        break
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tela])

  return (
    <Programa codigo="CtrlMedico" ferramentas={ferramentas}>
      {tela === 'lista' ? (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <PrimeTable
              codigo="CtrlMedico"
              action="lista"
              rows={10}
              habSearch
              parametros={{ idLocalAtendimento: localAtendimento?.[0] }}
              head={[
                'Código',
                'Nome',
                'Data Nascimento',
                'CPF',
                'Telefone',
                'E-mail',
              ]}
              line={(item) => [
                item[0],
                item[1],
                item[2] ? dayjs(item[2]).format('DD/MM/YYYY') : '',
                item[3]
                  ? item[3].replace(
                      /(\d{3})(\d{3})(\d{3})(\d{2})/,
                      '$1.$2.$3-$4',
                    )
                  : '',
                item[4]
                  ? item[4].replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3')
                  : '',
                item[5],
              ]}
              collumnsDate={[2]}
              onRowSelect={handleClick}
            />
          </Grid>
        </Grid>
      ) : (
        <Edicao {...{ dados, voltar }} />
      )}
    </Programa>
  )
}

export default MedicoCRUD
